import * as R from 'ramda';

export const reducerFactory = (resourceName, configuredHandlers = {}) => {
  const actionPostFix = resourceName.toUpperCase();
  const defaultState = {
    byId: {},
    draftsById: {},
    projectionKeys: [],
  };

  const handlers = {
    /*
    [`REQUEST_${actionPostFix}`]: (state, action) => {
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          query: action.payload.query,
          isLoading: true,
        },
      };
    },
    */
    /*
    [`ADD_${resource}`]: (state, action) => {
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isNew: true,
        },
      };
    },
    */
    [`DRAFT_${actionPostFix}`]: (state, action) => {
      return {
        ...state,
        draftsById: {
          ...state.draftsById,
          [action.payload.id]: action.payload.props,
        },
      };
    },
    [`UNDO_DRAFT_${actionPostFix}`]: (state, action) => {
      return {
        ...state,
        draftsById: {
          ...R.omit(R.pathOr([], ['payload', 'entities', resourceName, 'ids'], action), state.draftsById),
        },
      };
    },
    RECEIVE_ENTITIES: (state, action) => {
      return {
        ...state,
        byId: {
          ...state.byId,
          ...R.path(['payload', 'entities', resourceName, 'byId'], action),
        },
        draftsById: {
          ...R.omit(R.pathOr([], ['payload', 'entities', resourceName, 'ids'], action), state.draftsById),
        },
        projectionKeys: [...new Set([...state.projectionKeys, action.payload.projectionKey])],
        [action.payload.projectionKey]: {
          ...state[action.payload.projectionKey],
          isLoading: false,
          ids: R.path(['payload', 'entities', resourceName, 'ids'], action),
        },
      };
    },
    RECEIVE_ERRORS: (state, action) => {
      return {
        ...state,
        projectionKeys: [...new Set([...state.projectionKeys, action.payload.projectionKey])],
        [action.payload.projectionKey]: {
          ...state[action.payload.projectionKey],
          isLoading: false,
          errors: R.path(['payload', 'errors', resourceName], action),
        },
      };
    },
    RELEASE_PROJECTION_KEY: (state, action) => {
      return {
        ...R.omit([action.payload.projectionKey], state),
        projectionKeys: state.projectionKeys.filter(kw => kw !== action.payload.projectionKey),
      };
    },
    RELEASE_KEY_WINDOW: (state, action) => {
      return {
        ...R.omit([action.payload.projectionKey], state),
        projectionKeys: state.projectionKeys.filter(kw => kw !== action.payload.projectionKey),
      };
    },
    ...configuredHandlers,
  };

  return (state = defaultState, action) => (
    handlers[action.type] ? handlers[action.type](state, action) : state
  );
};

export default {
  reducerFactory,
};
